import styles from './table.module.scss';

interface OwnProps {
    value?: number | string | null;
    url?: string | null;
}

export function TableListCell({value, url}: OwnProps) {
    return (
        <div className={styles.table_list__cell}>
            <i className="fa-light fa-check" />
            {url ? (
                <span>
                    <a href={url}>{value ?? ''}</a>
                </span>
            ) : (
                <span>{value ?? ''}</span>
            )}
        </div>
    );
}
